export default __webpack_public_path__ + "appointments/static/media/strawberryblnde-red.34563a2d.png";